export const locale = {
  lang: 'fr',
  data: {
    NAV: {
      ADMIN: 'Espace admin',
      CATALOG: 'Catalogue',
      CUSTOMER: 'Clients',
      CUSTOMER_AREA: 'Espace client',
      CUSTOMERAREA: {
        PRODUCTION: 'Documents',
        RATE: 'Tarif',
      },
      DIRECTORY: 'Annuaire',
      HOME: {
        TITLE: 'Accueil',
      },
      INVOICE: 'Factures',
      ITEM: 'Articles',
      JOURNAL: 'Journaux',
      LABORATORY: 'Laboratoires',
      LABORATORY_AREA: 'Espace Laboratoire',
      MANUFACTURER: 'Fabricants',
      MATERIAL: 'Matières premières',
      PATIENT: 'Dossiers patients',
      PAYMENT: 'Règlements',
      PRODUCTION: 'Flux de production',
      PURCHASE_INVOICE: "Factures d'achat",
      RATE: 'Tarifs',
      RESOURCE: 'Ressources',
      SHADE: 'Teintes',
      USER: 'Comptes utilisateurs',
    },
  },
};
